// src/context/GetDataContext.js
import React, { createContext, useContext } from "react";

// Create context
const GetDataContext = createContext();

// Create provider
export const GetDataProvider = ({ children, getData }) => {
    return (
        <GetDataContext.Provider value={getData}>
            {children}
        </GetDataContext.Provider>
    );
};

// Custom hook to use the context
export const useGetData = () => {
    const context = useContext(GetDataContext);
    if (context === undefined) {
        throw new Error("useGetData must be used within a GetDataProvider");
    }
    return context;
};